<script setup lang="ts">

import type {HTMLAttributes} from "vue";
import {tw} from "../../../utils/tailwind.ts";
import {label} from "../../mixins/translations.ts";

interface Props {
    redirectUrl?: string
    class?: HTMLAttributes['class']
}

const props = withDefaults(defineProps<Props>(), {
    redirectUrl: '/',
})

</script>

<template>
    <div :class="tw('flex flex-col justify-center h-full text-center px-16 gap-8', props.class)">
        <strong v-text="label('site.cart.empty.title')"></strong>
        <p v-text="label('site.cart.empty.text')"></p>
        <a
            class="font-medium text-base px-16 py-4 leading-6 text-white transition rounded-lg bg-slate-700 hover:bg-slate-800 hover:duration-500 flex justify-center mx-auto"
            :href="redirectUrl"
        >
            {{ label('site.cart.empty.button') }}
        </a>
    </div>
</template>
